import {
  AxesBlueprintBuilderContext,
  AxesBlueprintUpdateContext,
  getXGridLinesBlueprintUpdater,
  getXTimeLabelsBlueprintUpdater,
  getYAxisBlueprintUpdater,
  getYGridLinesBlueprintUpdater,
  getYLabelsBlueprintUpdater,
} from 'components/Charting/axesBlueprint';

export const axesBlueprintBuilder = (context: AxesBlueprintBuilderContext) => {
  const axesBlueprintUpdaters = {
    xAxis: (() => {
      context.xAxisBottomG.append('line').classed('x-axis', true);

      return ({ innerHeight, xScale, xDomain }: AxesBlueprintUpdateContext) => {
        context.xAxisBottomG
          .select('.x-axis')
          .attr('x1', xScale(xDomain[0]) - 16)
          .attr('x2', xScale(xDomain[1]) + 20)
          .attr('y1', innerHeight)
          .attr('y2', innerHeight);
      };
    })(),

    ...getYAxisBlueprintUpdater(context),
    ...getXTimeLabelsBlueprintUpdater(context),
    ...getXGridLinesBlueprintUpdater(context),
    ...getYLabelsBlueprintUpdater(context),
    ...getYGridLinesBlueprintUpdater(context),
  };

  const update = (updateContext: AxesBlueprintUpdateContext) =>
    Object.values(axesBlueprintUpdaters).forEach((blueprintItemUpdater) =>
      blueprintItemUpdater(updateContext),
    );

  return { update };
};
